import React from 'react';

const HeroSection = ({ title, subtitle, backgroundImage, children, className = "" }) => {
  return (
    <div 
      className={`relative ${className || 'hero-section'} flex items-center ${
        backgroundImage 
          ? `bg-cover bg-center` 
          : 'bg-nihal-primary'
      }`}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="container relative z-10">
        <h1 className="text-2xl font-bold text-white">{title}</h1>
        {subtitle && <p className="text-sm text-white mt-4">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
};

export default HeroSection;